module.exports = "http://cdn.realive.com.ua/src/views/player/help/images/news2.jpg";